<template>
  <div>
    <header class="main-header">
        <ProfileBar />
        <NavBar />
        <div class="container-fluid main-container-fluid mb-2">
        </div>
    </header>
    <div id="right-panel" class="right-panel rounded-lg">
        <div class="main-content">
        <slot />          
        </div>
        <div class="clear"></div>
    </div>
    <FooterBar />
  </div>
</template>

<script>
import ProfileBar from '@/app/shared/layouts/components/header/profile-bar.vue';
import NavBar from '@/app/shared/layouts/components/header/nav-bar.vue';
import FooterBar from '@/app/shared/layouts/components/footer/footer.vue';

localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? import('./components/header/theme/header.scss') : import('./components/header/theme/header-rtl.scss');
localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? import('./components/footer/theme/footer.scss') : import('./components/footer/theme/footer-rtl.scss');



export default {
  name: 'default',
  data() {
    return {
    navEl: false
    }
  },
  components: {
    ProfileBar,
    NavBar,
    FooterBar
  },
};
</script>

<style lang="scss" scoped>
  #right-panel{
    margin: 100px auto 0 auto;
    width: 100%;
    flex: 1;
  }
</style>